import styled from 'styled-components'

export const ChildrenDiv = styled.div`
  display: flex;
  background-color: white;
  width: 100%;
  height: 80px;
`
export const ChargeDiv = styled.div`
  display: flex;
  background-color: white;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
`

export const ChildrenInfoContainer = styled.div`
  display: flex;
  background-color: white;
  width: 100%;
  border-bottom: solid 1px;
  border-bottom-color: #CCCCCC;
  display: flex;
  flex-direction: column;
`


export const ChildrenContainer = styled.div`
  overflow-y: scroll;
  width: 100%;
  height: calc(100% - 245px);
  position: absolute;
`
export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const Continue = styled.div`
  width: 100%;
  height: 80px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  bottom: 0;
  @media (max-width: 763px) {
    position: fixed;
    bottom: 0;
  }
`
export const SelectAllContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

`
export const Div = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IconsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
export const Img = styled.img`
  @media (max-width: 763px) {
    width: 20px;
    height: 20px;
  }
`

export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
  padding: 16px;
  cursor: pointer;
`

export const ProfileDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  margin-right: 10px;
`

export const ProfileDivOverlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 100px;
  position: absolute;
`

export const InfoDiv = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  position: relative;
`
export const InfoDivOverlay = styled.div`
  flex:1;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(2,2,2,0);
  position: absolute;
  z-index: 9999;

`

export const NameDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 763px) {
    font-size: 15px;
  }
`

export const Charge = styled.span`
  color: #CCCCCC;
  font-size: 16px;
  margin-left: 30px;
`



// WEBPACK FOOTER //
// ./src/Components/Activity/SelectKids.styles.jsx